import { createEvent, createStore } from 'effector'

export const actions = {
  setTokens: createEvent<AuthTokens>('setTokens'),
  setScopes: createEvent<AuthScope[]>('setScopes'),
  reset: createEvent('reset'),
}

const initialState: AuthState = {
  tokens: undefined,
  scopes: [],
}

export const store = createStore<AuthState>(initialState, { name: 'auth' })
  .on(actions.setTokens, (s, tokens) => ({ ...s, tokens }))
  .on(actions.setScopes, (s, scopes) => ({ ...s, scopes }))
  .on(actions.reset, () => initialState)
